import toH from 'hast-to-hyperscript'
import React from 'react'

/**
 * Converts hast to React nodes. This is a reimplementation of the package
 * `rehype-react`.
 */

const makeToReact = ({ components } /*: Options = {} */) => {
  const createElement = (
    tag /*: string */,
    props /*: Propsish | void */,
    children /*: React.ReactNode */
  ) => {
    let component

    if (components && components[tag]) {
      component = components[tag]
    }

    return React.createElement(component || tag, props || {}, children)
  }

  const compile = (node /*: any */) /*: React.ReactNode */ => {
    return toH(createElement, node)
  }

  return compile
}

export default makeToReact
